module.exports = __webpack_public_path__ + "static/media/calendarIcon.0c1285c2.svg";